import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Flex from '@components/Flex';

import { getImage } from '@services/images.service';
import getImagesFromOnlinePaymentMethods from '@utils/payments/getImagesFromOnlinePaymentMethods';
import messages from './messages';
import PaymentImage from './PaymentImage';
import Subtitle from '../Subtitle';

const ImagesContainer = styled(Flex)`
  flex-wrap: wrap;
  margin-bottom: 26px;
`;

function getImageFromServicePaymentMethods(image) {
  const options = {
    type: 'online_payment_profile',
    name: image,
    quality: 70,
    width: 100,
  };

  return getImage(options);
}

function OnlinePaymentMethods({ items }) {
  if (items.length === 0) return null;
  const cardsImages = getImagesFromOnlinePaymentMethods(items);

  return (
    <>
      <FormattedMessage {...messages.onlinePayment}>
        {label => <Subtitle>{label}</Subtitle>}
      </FormattedMessage>

      <ImagesContainer>
        {cardsImages.map(option => (
          <PaymentImage
            key={option.id}
            aria-label={option.name}
            src={getImageFromServicePaymentMethods(option.image)}
          />
        ))}
      </ImagesContainer>
    </>
  );
}

OnlinePaymentMethods.propTypes = {
  items: PropTypes.array.isRequired,
};

export default React.memo(OnlinePaymentMethods);
